import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";

export const HowActionsWithRights: React.FC = () => {
  return <div id={"HowActionsWithRights"}>
    <h2>
      Авторские права
    </h2>
    <br />

    <div id={"HowAddRightsOnRelease"}>
      <h4>
        Как добавить авторские права на релизы
      </h4>
      <p>
        Для добавления авторских прав перейдите в раздел "Авторские права" и выберете искомый релиз, отметив его
        галочкой в левом столбце. Вы можете искать релизы по названию, исполнителю или ISRC.
        <br />
        <br />
        После выбора нужного релиза нажмите кнопку "+ Добавить" в правом верхнем углу экрана. Заполните необходимые поля
        в открывшемся поле:
        <br />
        <br />
        <ul className={"list-disc"}>
          <li>
            Укажите долю авторских прав. Доля указывается без дополнительных символов. Например, если доля 100%, то
            указывается 100, если 50%, то указывается 50
          </li>
          <li>Укажите External ID. Это уникальный код релиза в вашем авторском каталоге, к нему будут привязаны все
            выбранные на предыдущем этапе релизы
          </li>
          <li>Укажите авторов. Необязательное поле</li>
          <li>Укажите дату выпуска права</li>
          <li>Укажите дату истечения права или оставьте поле пустым</li>
          <li>Выберете страны. Вы можете выбрать из перечня стран СНГ или отметить весь мир</li>
        </ul>
        Вы можете выбрать сразу несколько идентичных релизов для массового добавления авторских прав. Пожалуйста,
        убедитесь, что все выбранные релизы идентичны с точки зрения авторства и доли авторских прав, поскольку после
        подтверждения всем выбранным релизам будет присвоен один авторский код.
      </p>
    </div>
    <br />
    <div id={"HowGroupAddRightsOnRelease"}>
      <h4>
        Массовое добавление авторских прав
      </h4>
      <p>
        Заполните таблицу по <a href={"/help/Шаблон_для_авторских_прав.xlsx"} rel="noopener" target={"_blank"}>Шаблону <FontAwesomeIcon
        className={"text-xs"} icon={faArrowUpRightFromSquare} /></a>, ниже пояснения по некоторым пунктам:
        <br />
        <br />
        <ul className={"list-disc"}>
          <li>
            Код (External ID) — это уникальный код релиза в вашем авторском каталоге.
            Авторские доли указываются без дополнительных символов. Например, если доля 100%, то указывается 100, если
            50%, то указывается 50.
          </li>
          <li>
            Territories - оставьте поле пустым, если авторские права распространяются без территориальных ограничений.
            Если права действуют на всей территории СНГ, укажите весь список — RU,AZ,AM,BY,KZ,KG,MD,TJ,TM,UZ,UA,GE или
            укажите отдельные страны из списка.
          </li>
          <li>Start date — дата выпуска права, указывается в формате дд.мм.гггг</li>
          <li>Expire date — дата истечения права, указывается в формате дд.мм.гггг, необязательное поле.</li>
          <li>Track Ids — оставьте поле пустым.</li>
        </ul>
        После этого перейдите в раздел "Авторские права", нажмите на кнопку "Загрузить Excel-файл" и выберете файл с
        заполненной ранее таблицей.
      </p>
    </div>

    <br />
    <div id={"HowRevokeRightsOnRelease"}>
      <h4>
        Как изъять авторские права
      </h4>
      <p>
        Выберите нужные релизы и нажмите на кнопку "Изъять" в правом верхнем углу экрана. В появившемся поле укажите
        дату окончания прав. Обратите внимание, что нельзя указать дату в прошлом.
        <br />
        <br />
        Вы также можете массово изъять авторские права, загрузив специальную таблицу по <a
        href={"/help/Шаблон_для_авторских_прав.xlsx"} rel="noopener" target={"_blank"}>Шаблону <FontAwesomeIcon
        className={"text-xs"} icon={faArrowUpRightFromSquare} /></a> xlsx-файл. Заполните таблицу
        согласно инструкции, в поле "Expire date" впишите дату истечения прав
        <br />
        <br />
        Изъятие авторских прав подразумевает лишь снятие авторских долей, но не убирает вашу лицензию с треков на
        площадках. При необходимости изъять непосредственно треки просим воспользоваться инструкцией "Как изъять
        отдельный трек в альбоме".
      </p>
    </div>
  </div>;
};
